import React from 'react'
import './index.css'

type PaddedBlockProps = {
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export const PaddedBlock = ({ className = '', style, children }: PaddedBlockProps) => (
  <div className={`PaddedBlock--root ${className}`} style={style}>
    {children}
  </div>
)
